import callAPiBase from './base';

const sectionsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sectionList',
      method: 'GET',
      useToken: true,
      title: 'Section - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sectionCreate',
      method: 'POST',
      useToken: true,
      title: 'Section - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/sectionUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Section - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/sectionDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Section - Delete',
      params,
    }),
};

export { sectionsApi };
export default sectionsApi;
